<template>
  <div
    class="tab-pane"
    id="pills-contacts"
    role="tabpanel"
    aria-labelledby="pills-contacts-tab"
    v-bind:class="$route.name == 'Members' ? 'active' : ''"
  >
    <!-- Start Contact content -->
    <div>
      <div class="px-4 pt-4">
        <div class="d-flex align-items-start">
          <div class="flex-grow-1">
            <h4 class="mb-4">All Members</h4>
          </div>
        </div>
      </div>
      <!-- end p-4 -->

      <div class="chat-group-list">
        <div class="sort-contact">
          <ul id="contact-sort-A" class="list-unstyled contact-list">
            <li v-for="(user, index) in users" :key="index">
              <div class="d-flex align-items-center">
                <div class="flex-shrink-0 me-2">
                  <div class="avatar-xs">
                    <img
                      v-if="user.profile_image != 'non'"
                      :src="user.profile_image"
                      class="img-fluid rounded-circle"
                      v-alt="user.username"
                    />
                    <img
                      v-else
                      :src="
                        $store.state.config.frontpoint +
                        'storage/default-user-photo.png'
                      "
                      class="img-fluid rounded-circle"
                      v-alt="user.username"
                    />
                  </div>
                </div>
                <div class="flex-grow-1">
                  <router-link
                    :to="{
                      name: 'visitProfile',
                      params: { username: user.username },
                    }"
                    custom
                    v-slot="{ navigate }"
                  >
                    <span
                      role="link"
                      class="nav-link py-2 ps-2"
                      @click="navigate"
                      aria-current="true"
                      @keypress.enter="navigate"
                    >
                      {{ user.username }}
                    </span>
                  </router-link>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- end contact lists -->
    </div>
    <!-- Start Contact content -->
  </div>
</template>

<script>
export default {
  name: "Members",

  data() {
    return {
      users: [],
      roles: "",
      activation: "",
      lastindexPost: 0,
      currentPage: 1,
      perPage: 100,
      countOfPages: 0,
      currnetUser: undefined,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.loadUsers(null);
    });
  },
  methods: {
    loadUsers(directive) {
      if (directive != null) {
        if (directive) {
          this.lastindexPost += this.perPage;
          this.currentPage++;
        } else {
          this.lastindexPost -= this.perPage;
          this.currentPage--;
        }
      }

      this.$store.state.modules.api
        .getAllUsers(
          JSON.parse(localStorage.account).token,
          this.lastindexPost,
          this.perPage
        )
        .then((resp) => {
          if (resp.status == 200) {
            this.users = resp.data.users;
            this.countOfPages = resp.data.countOfPages;
          } else {
            this.users = undefined;
          }
        })
        .catch((err) => {
          this.users = undefined;
        });
    },
  },
};
</script>
